import TransferenciaPosse from '../../spa/transferencia-posse/TransferenciaPosse';
import TransferenciaPosseAbas from '../../spa/transferencia-posse/TransferenciaPosseAbas';
import TransferenciaPosseDefinitivaForm from '../../spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaForm';

export default {
  path: 'transferencia-posse',
  component: TransferenciaPosse,
  children: [
    {
      path: '',
      name: 'transferencia-posse',
      component: TransferenciaPosseAbas,
    },
    {
      path: 'transf-definitiva',
      name: 'novaTransferenciaDefinitiva',
      component: TransferenciaPosseDefinitivaForm,
    },
  ],

};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/transferencia-posse.js